(() => {
  const initCartMarketTabs = (root = document) => {
    root.querySelectorAll('[data-hos-market-tabs]').forEach((container) => {
      if (container.dataset.initialized === 'true') return;
      container.dataset.initialized = 'true';

      const tabs = Array.from(container.querySelectorAll('[role="tab"]'));
      const panels = Array.from(container.querySelectorAll('[role="tabpanel"]'));

      const selectTab = (tab) => {
        tabs.forEach((item) => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        panels.forEach((panel) => {
          panel.hidden = panel.id !== tab.getAttribute('aria-controls');
        });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => selectTab(tab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let nextIndex = index;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          tabs[nextIndex].focus();
          selectTab(tabs[nextIndex]);
        });
      });
    });
  };

  const initLoginValidation = (root = document) => {
    root.querySelectorAll('[data-hos-login-form], #hos-customer-login').forEach((form) => {
      if (form.dataset.initialized === 'true') return;
      form.dataset.initialized = 'true';
      form.noValidate = true;

      const email = form.querySelector('input[type="email"]');
      const password = form.querySelector('input[type="password"]');
      const emailError = form.querySelector('[data-hos-email-error]');
      const passwordError = form.querySelector('[data-hos-password-error]');

      form.addEventListener('submit', (event) => {
        let firstInvalid = null;

        if (email) {
          const missing = email.value.trim() === '';
          const malformed = !missing && !email.validity.valid;
          email.setAttribute('aria-invalid', String(missing || malformed));
          emailError.textContent = missing
            ? 'Enter your email address.'
            : malformed
              ? 'Enter a valid email address.'
              : '';
          if ((missing || malformed) && !firstInvalid) firstInvalid = email;
        }

        if (password) {
          const missing = password.value === '';
          password.setAttribute('aria-invalid', String(missing));
          passwordError.textContent = missing ? 'Enter your password.' : '';
          if (missing && !firstInvalid) firstInvalid = password;
        }

        if (firstInvalid) {
          event.preventDefault();
          firstInvalid.focus();
        }
      });
    });
  };

  const initShoppableVideoForms = (root = document) => {
    root.querySelectorAll('[data-hos-shoppable-videos]').forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      section.querySelectorAll('.hos-shoppable-video-card__variant').forEach((select) => {
        const form = select.closest('form');
        const submit = form?.querySelector('[name="add"]');
        if (!submit) return;

        const updateAvailability = () => {
          const option = select.selectedOptions[0];
          const available = option?.dataset.available === 'true';
          submit.disabled = !available;
          submit.setAttribute('aria-disabled', String(!available));
          submit.textContent = available
            ? submit.dataset.addToCartText
            : 'Sold out';
        };

        select.addEventListener('change', updateAvailability);
        updateAvailability();
      });
    });
  };

  const init = (root = document) => {
    initCartMarketTabs(root);
    initLoginValidation(root);
    initShoppableVideoForms(root);
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
